var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq18(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.571484,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8078,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.3953,
    y1: 12.1824,
    x2: 49.6316,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.721462,
    y1: 49.8543,
    x2: 11.9578,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.1574,
    y1: 38.6199,
    x2: 49.3938,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.483616,
    y1: 0.944118,
    x2: 11.7199,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.434 20.844V19.962H21.814V30H20.82V20.844H19.434ZM25.9439 24.792C25.3652 24.6053 24.9219 24.3113 24.6139 23.91C24.3152 23.5087 24.1659 23.0233 24.1659 22.454C24.1659 21.95 24.2919 21.502 24.5439 21.11C24.8052 20.7087 25.1832 20.396 25.6779 20.172C26.1726 19.9387 26.7652 19.822 27.4559 19.822C28.1466 19.822 28.7392 19.9387 29.2339 20.172C29.7286 20.396 30.1019 20.7087 30.3539 21.11C30.6152 21.502 30.7459 21.95 30.7459 22.454C30.7459 23.014 30.5919 23.4993 30.2839 23.91C29.9852 24.3207 29.5466 24.6147 28.9679 24.792C29.6026 24.9507 30.1019 25.254 30.4659 25.702C30.8299 26.15 31.0119 26.696 31.0119 27.34C31.0119 27.9373 30.8626 28.46 30.5639 28.908C30.2746 29.3467 29.8592 29.6873 29.3179 29.93C28.7859 30.1727 28.1652 30.294 27.4559 30.294C26.7466 30.294 26.1212 30.1727 25.5799 29.93C25.0479 29.6873 24.6326 29.3467 24.3339 28.908C24.0446 28.46 23.8999 27.9373 23.8999 27.34C23.8999 26.696 24.0819 26.15 24.4459 25.702C24.8099 25.254 25.3092 24.9507 25.9439 24.792ZM29.7939 22.566C29.7939 21.95 29.5839 21.474 29.1639 21.138C28.7439 20.802 28.1746 20.634 27.4559 20.634C26.7372 20.634 26.1679 20.802 25.7479 21.138C25.3279 21.4647 25.1179 21.9407 25.1179 22.566C25.1179 23.1447 25.3326 23.6067 25.7619 23.952C26.1912 24.2973 26.7559 24.47 27.4559 24.47C28.1559 24.47 28.7206 24.2973 29.1499 23.952C29.5792 23.6067 29.7939 23.1447 29.7939 22.566ZM27.4559 25.226C26.6906 25.226 26.0652 25.3987 25.5799 25.744C25.0946 26.0893 24.8519 26.612 24.8519 27.312C24.8519 27.984 25.0852 28.5113 25.5519 28.894C26.0186 29.2767 26.6532 29.468 27.4559 29.468C28.2492 29.468 28.8792 29.2767 29.3459 28.894C29.8126 28.502 30.0459 27.9747 30.0459 27.312C30.0459 26.6213 29.8032 26.1033 29.3179 25.758C28.8419 25.4033 28.2212 25.226 27.4559 25.226Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq18);
export default __webpack_public_path__ + "static/media/fq18.50fefb5331db7af0d51be43fe9b4d867.svg";
export { ForwardRef as ReactComponent };